// removed by extract-text-webpack-plugin
module.exports = {"form":"c-RegisterFormWizard__form","buttons":"c-RegisterFormWizard__buttons"};